import {
  CREATE_FORMS,
  UPDATE_PROPERTIES,
  UpdatePropertiesForm,
  DataCreateForms,
  ADD_FORMS,
  DragDelete,
  DragAdd,
  ADD_THEME_INFO,
  ThemeInfo,
  AUTO_COMPLETE_VARIABLES,
  SAVE_ORIGINAL_FORM_DATA,
  SET_SELECTED_FORM_DATA,
  REMOVE_FORM,
  UPDATE_FORM_WIDGET_PROPERTIES
} from "./types";
import { store } from "../..";
import * as _ from "lodash";
import { getRandomId } from "../../../utils/random-id";
import { findIdSelector } from "../../../pages/apps/Assisted/forms/create/reduxSelector";
import { logger } from "../../../constant/winston";

export const updateFields = (fields: any, ids: any, data: any) => {
  return new Promise((resolve, reject) => {
    let field = fields;
    let id = "";
    let resFind: any;
    _.each(ids, (value, key: number) => {
      id += key === 0 ? value : "#" + value;
      const find = _.find(field, ["id", id.trim()]);
      if (find) {
        field = find.fields;
        if (find.id === ids.join("#")) {
          resFind = find;
          resFind?.fields?.push(data);
        }
      }
    });
    resolve(fields);
  });
};

export const updateProps = (
  fields: any,
  ids: any,
  data: any,
  autoMerge: boolean = true
) => {
  return new Promise((resolve, reject) => {
    let fieldsCopy =  JSON.parse(JSON.stringify(fields))
    let field = fieldsCopy;
    let id = "";
    let min: string,
      max: string,
      minlength: string,
      maxlength: string,
      pattern: string,
      errorMessage: string,
      dataMin: string,
      dataMax: string,
      dataMinlength: string,
      dataMaxlength: string,
      dataPattern: string,
      dataErrorMessage: string,
      dataEmpty: string;

    _.each(ids, (value, key: number) => {
      id += key === 0 ? value : "#" + value;
      let find = _.find(field, ["id", id.trim()]);
      if (find) {
        field = find.fields;
        if (find.id === ids.join("#")) {
          autoMerge && _.merge(find, data);
          const { properties } = find;
          if (properties) {
            min = properties.min;
            max = properties.max;
            maxlength = properties.maxlength;
            minlength = properties.minlength;
            pattern = properties.pattern;
            errorMessage = properties.errorMessage;
          }
          if (data.properties) {
            dataMin = data.properties.min;
            dataMax = data.properties.max;
            dataMaxlength = data.properties.maxlength;
            dataMinlength = data.properties.minlength;
            dataPattern = data.properties.pattern;
            dataErrorMessage = data.properties.errorMessage;
            dataEmpty = data.properties.empty;
          }
          if (find.type === "Scanner") {
            //Forcefully re-assigning since _.merge will keep the last object even when deleting from the option array
            if (
              find.properties &&
              find.properties.bindVariables &&
              data.properties &&
              data.properties.bindVariables
            ) {
              find.properties.bindVariables = data.properties.bindVariables;
            }
            // when switching to single scanner type we need to delete bindVariables for Multiple scanner.
            if (
              find.properties &&
              find.properties.bindVariables &&
              data.properties &&
              data.properties.multiple !== undefined &&
              !data.properties.multiple
            ) {
              delete find.properties.bindVariables;
            }
            // when switching to multiple scanner type we need to delete some variables associated to single scanner.
            if (
              find.properties &&
              data.properties &&
              data.properties.multiple !== undefined &&
              data.properties.multiple
            ) {
              if (find.properties.parse) {
                delete find.properties.parse;
              }
              //this deletes the bind on changing scanner type
              // if (find.bind) {
              //   delete find.bind;
              // }
            }
            if (
              find.properties &&
              data.properties &&
              data.properties.scannerTypeVariables
            ) {
              find.properties.scannerTypeVariables = data.properties.scannerTypeVariables;
            }
            if (
              find.properties &&
              find.properties.scannerTypeVariables &&
              data.properties &&
              data.properties.scannerTypeVariables !== undefined &&
              !data.properties.scannerTypeVariables
            ) {
              delete find.properties.scannerTypeVariables;
            }
          }

          if (find.type === "Uploader") {
            if (
              find.properties &&
              data.properties &&
              data.properties.fileType
            ) {
              find.properties.fileType = data.properties.fileType;
            }
            if (
              find.properties &&
              find.properties.fileType &&
              data.properties &&
              data.properties.fileType !== undefined &&
              !data.properties.fileType
            ) {
              delete find.properties.fileType;
            }
          }
          if (find.type === "CheckList" || find.type === "DocumentCollector") {
            // data.preload.bindParams
            if (
              find.data &&
              data.data &&
              find.data.preload &&
              data.data.preload &&
              find.data.preload.bindParams &&
              data.data.preload.bindParams
            ) {
              find.data.preload.bindParams = data.data.preload.bindParams;
            }
          }

          //Forcefully re-assigning since _.merge will keep the last object even when deleting from the option array
          if (
            find.type === "RadioButton" ||
            find.type === "CheckBox" ||
            find.type === "Select" ||
            find.type === "Uploader" ||
            find.type === "Table" ||
            find.type === "Input" ||
            find.type === "PdfViewer"
          ) {
            if (
              find.data &&
              data.data &&
              find.data.options &&
              data.data.options
            ) {
              find.data.options = data.data.options;
            }
            if (find.data && data.data && data.data.uploadList) {
              find.data.uploadList = data.data.uploadList;
            }
          }
          if (data?.formProperties?.importedAssets && find?.formProperties?.importedAssets){
            find.formProperties.importedAssets = data?.formProperties?.importedAssets;
          }
          if (data.fields) {
            find.fields = data.fields;
          }
          if ((min || max || minlength || maxlength || pattern || errorMessage)
            && (dataMin || dataMax || dataMinlength || dataMaxlength || dataPattern || dataErrorMessage || dataEmpty)) {
            // empty variable is used only as an indication to handle it here
            delete data['empty']
            const excludeList = ["min", "max", "minlength", "maxlength", "pattern", "errorMessage"];
            for (let i in excludeList) {
              if (properties[excludeList[i]]) {
                delete properties[excludeList[i]];
              }
            }
            find.properties = { ...properties, ...data.properties }
          }
        }
      }
    });
    resolve(fieldsCopy);
  });
};

export const addTabs = (formId: string, tabId: string, tabName?: string) => {
  return async (dispatch: any) => {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[formId];
    const tabKey = getRandomId();

    let finalOP: any = [];
    if (!formcreation || (formcreation && _.size(formcreation) === 0)) {
      finalOP = [
        {
          id: tabId,
          type: "TabBar",
          name: tabName || tabId,
          tabKey: tabKey,
          visibility: true,
          fields: [],
          properties: {},
        },
      ];
    } else {
      const find = _.find(formcreation, ["id", tabId]);
      if (find) {
        finalOP = [...formcreation];
      } else {
        finalOP = [
          ...formcreation,
          {
            id: tabId,
            type: "TabBar",
            name: tabName || tabId,
            tabKey: tabKey,
            visibility: true,
            fields: [],
            properties: {},
          },
        ];
      }
    }
    dispatch({
      type: CREATE_FORMS,
      data: {
        id: formId,
        data: finalOP,
      },
    });
  };
};

export function updateForms(data: any) {
  return async function (dispatch: any) {
    dispatch({
      type: CREATE_FORMS,
      data
    })
  }
}

export function addFormJson(data: DataCreateForms, providedForm?: any) {
  return async function (dispatch: any) {
    let formcreation: any;
    if (!providedForm) {
      const reduxStore = _.cloneDeep(store.getState());
      formcreation = reduxStore.formcreation[data.formId];
    } else {
      formcreation = providedForm;
    }

    let finalOP: any = [];
    if (!formcreation || (formcreation && _.size(formcreation) === 0)) {
      finalOP = [
        {
          id: "tab-0",
          type: "TabBar",
          name: "Basic Information",
          fields: [data.data],
        },
      ];
    } else {
      const splits: any = data.data.id.split("#");
      const ids = _.reject(splits, splits.splice(-1, 1));
      finalOP = await updateFields(formcreation, ids, data.data);
    }
    dispatch({
      type: CREATE_FORMS,
      data: {
        id: data.formId,
        data: finalOP,
      },
    });
  };
}

export function addForms(data: any) {
  return {
    type: ADD_FORMS,
    data: data,
  };
}

export function updateFormProperties(data: UpdatePropertiesForm) { 
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[data.formid!];
    try {
      let finalOP: any = [];
      const splits: any = data.id!.split("#");
      // const ids = _.reject(splits, splits.splice(-1, 1));
      finalOP = await updateProps(formcreation, splits, data.data);
      dispatch({
        type: UPDATE_PROPERTIES,
        data: {
          id: data.formid,
          data: finalOP,
        },
      });
    } catch (e) {
      logger.error("Error from update form props", e);
    }
  };
}

export function updateFormWidgetProperties(data: any) {
  return async function (dispatch: any) {
    try {
      dispatch({
        type: UPDATE_PROPERTIES,
        data: {
          id: data.formid,
          data: data.data.result,
        },
      });
    } catch (e) {
      logger.error("Error from update form props", e);
    }
  };
}

export function removeComponentFromJson(
  data: DragDelete,
  undoMode: boolean = false
) {
  return async function (dispatch: any) {
    let finalJSON: any;

    if (!undoMode) {
      finalJSON = await deleteComponent(data);
    } else {
      const reduxStore = _.cloneDeep(store.getState());
      const formcreation = reduxStore.formcreation[data.formid!];
      const containerSplits: any = data.draggedItemContainer.id!.split("#");
      finalJSON = await updateProps(
        formcreation,
        containerSplits,
        { fields: data.draggedItemContainer.fields },
        false
      );
    }

    dispatch({
      type: UPDATE_PROPERTIES,
      data: {
        id: data.formid,
        data: finalJSON,
      },
    });
  };
}

export function addComponentToJson(data: DragAdd) {
  return async function (dispatch: any) {
    const dropAddedJson: any = await addComponent(data);
    dispatch({
      type: UPDATE_PROPERTIES,
      data: {
        id: data.formid,
        data: dropAddedJson.json,
      },
    });
  };
}

export function sortComponentsOnDrag(data: any) {
  const { formId, draggedItem, container, addIndex } = data;
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[formId];
    const draggedItemContainerSplits: any = container.id!.split("#");

    const removedDraggedItem = container.fields.filter(
      (item: any) => item.id !== draggedItem.id
    );
    // Add dragged item into a specific index
    removedDraggedItem.splice(addIndex, 0, draggedItem);
    const finalJson = await updateProps(
      formcreation,
      draggedItemContainerSplits,
      { fields: removedDraggedItem },
      false
    );
    dispatch({
      type: UPDATE_PROPERTIES,
      data: {
        id: formId,
        data: finalJson,
      },
    });
  };
}

export const reorderTabs = (orderedTabs: string[], formId: string) => {
  return async (dispatch: any) => {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[formId];
    let formProperties = {}
    let onTaskEvent = "";
    if(formcreation && formcreation.length && formcreation[0]['formProperties']){
      formProperties = formcreation[0]['formProperties']
      delete formcreation[0]['formProperties'];
    }
    if (formcreation?.[0]?.properties?.onTaskEvent) {
      onTaskEvent = formcreation[0].properties.onTaskEvent
      delete formcreation[0].properties["onTaskEvent"]
    }
    let theme = (formcreation && formcreation.length && formcreation[0]['theme']) ? formcreation[0]['theme'] : {};
    try {
      let finalOP: any[] = [];
      _.each(orderedTabs, (tabId: string, key: number) => {
        let find = _.find(formcreation, ["id", tabId]);
        if (find) {
          finalOP.push(find);
        }
      });
      if (finalOP &&  finalOP.length){
        finalOP[0].formProperties = formProperties;
        finalOP[0].theme = theme;
        finalOP[0].properties = { ...finalOP[0].properties, onTaskEvent}
      }
      dispatch({
        type: UPDATE_PROPERTIES,
        data: {
          id: formId,
          data: finalOP,
        },
      });
    } catch (e) { }
  };
};

export const deleteTabs = (deleteTabId: string, formId: string) => {
  return async (dispatch: any) => {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[formId];
    let formProperties = (formcreation && formcreation.length && formcreation[0]['formProperties']) ? formcreation[0]['formProperties'] : {};
    let theme = (formcreation && formcreation.length && formcreation[0]['theme']) ? formcreation[0]['theme'] : {};
    try {
      let finalOP: any[] = [];
      _.each(formcreation, (tab: any, key: number) => {
        if (deleteTabId !== tab.id) {
          finalOP.push(tab);
        }
      });
      if (finalOP &&  finalOP.length){
        finalOP[0].formProperties = formProperties;
        finalOP[0].theme = theme;
      }
      dispatch({
        type: UPDATE_PROPERTIES,
        data: {
          id: formId,
          data: finalOP,
        },
      });
    } catch (e) { }
  };
};

async function deleteComponent(data: DragDelete, providedForm?: any) {
  let formcreation: any;
  if (!providedForm) {
    const reduxStore = _.cloneDeep(store.getState());
    formcreation = reduxStore.formcreation[data.formid!];
  } else {
    formcreation = providedForm;
  }

  let dragDeleted: any = [];
  let dragDeletedJson: any = [];
  const draggedItemContainerSplits: any =
    data.draggedItemContainer.id!.split("#");

  //Remove dragged item from its container
  dragDeleted = data.draggedItemContainer.fields.filter(
    (item: any) => item.id !== data.itemId
  );

  const dragDeletedData = {
    fields: dragDeleted,
  };

  dragDeletedJson = await updateProps(
    formcreation,
    draggedItemContainerSplits,
    dragDeletedData,
    false
  );
  return dragDeletedJson;
}

async function addComponent(data: DragAdd, providedForm?: any) {
  let formcreation: any;
  // let generatedID: string = '';

  if (!providedForm) {
    const reduxStore = _.cloneDeep(store.getState());
    formcreation = reduxStore.formcreation[data.formid!];
  } else {
    formcreation = providedForm;
  }
  let dropAdded: any = [];
  let dropAddedJson: any = [];
  const droppedContainerSplits: any = data.droppedContainer.json.id!.split("#");

  dropAdded = [...data.droppedContainer.json.fields];

  dropAdded.push({ ...data.draggedItem });

  const dropAddedData = {
    fields: dropAdded,
  };

  dropAddedJson = await updateProps(
    formcreation,
    droppedContainerSplits,
    dropAddedData,
    false
  );

  return dropAddedJson;
}

export function addRemoveOnDragComplete(
  dragDeleteData: DragDelete,
  dragAddData: DragAdd,
  undoMode: boolean = false
) {
  return async function (dispatch: any) {
    let bufferForm: any;
    let finalForm: any;

    if (!undoMode) {
      // if (
      //   dragAddData.droppedContainer.json.id.startsWith(
      //     dragDeleteData.draggedItemContainer.id
      //   )
      // ) {
      //   bufferForm = await deleteComponent(dragDeleteData);
      //   finalForm = await addComponent(dragAddData, bufferForm);
      // } else if (
      //   dragDeleteData.draggedItemContainer.id.startsWith(
      //     dragAddData.droppedContainer.json.id
      //   )
      // ) {
      //   bufferForm = await addComponent(dragAddData);
      //   finalForm = await deleteComponent(dragDeleteData, bufferForm);
      // } else {
      //   bufferForm = await deleteComponent(dragDeleteData);
      //   finalForm = await addComponent(dragAddData, bufferForm);
      // }
      if (dragDeleteData.draggedItemContainer.id.startsWith(dragAddData.droppedContainer.json.id)) {
        bufferForm = await addComponent(dragAddData);
        finalForm = await deleteComponent(dragDeleteData, bufferForm);
      } else {
        bufferForm = await deleteComponent(dragDeleteData);
        finalForm = await addComponent(dragAddData, bufferForm);
      }
    } else {
      const reduxStore = _.cloneDeep(store.getState());
      const formcreation =
        reduxStore.formcreation[dragDeleteData.formid! || dragAddData.formid!];
      const droppedContainerSplits: any =
        dragAddData.droppedContainer.json.id!.split("#");
      const itemContainerSplits: any =
        dragDeleteData.draggedItemContainer.id!.split("#");

      // if (
      //   dragAddData.droppedContainer.json.id.startsWith(
      //     dragDeleteData.draggedItemContainer.id
      //   )
      // ) {
      //   bufferForm = await updateProps(
      //     formcreation,
      //     itemContainerSplits,
      //     { fields: dragDeleteData.draggedItemContainer.fields },
      //     false
      //   );
      //   finalForm = await updateProps(
      //     bufferForm,
      //     droppedContainerSplits,
      //     { fields: dragAddData.droppedContainer.json.fields },
      //     false
      //   );
      // } else if (
      //   dragDeleteData.draggedItemContainer.id.startsWith(
      //     dragAddData.droppedContainer.json.id
      //   )
      // ) {
      //   bufferForm = await updateProps(
      //     formcreation,
      //     droppedContainerSplits,
      //     { fields: dragAddData.droppedContainer.json.fields },
      //     false
      //   );
      //   finalForm = await updateProps(
      //     bufferForm,
      //     itemContainerSplits,
      //     { fields: dragDeleteData.draggedItemContainer.fields },
      //     false
      //   );
      // } else {
      //   bufferForm = await updateProps(
      //     formcreation,
      //     itemContainerSplits,
      //     { fields: dragDeleteData.draggedItemContainer.fields },
      //     false
      //   );
      //   finalForm = await updateProps(
      //     bufferForm,
      //     droppedContainerSplits,
      //     { fields: dragAddData.droppedContainer.json.fields },
      //     false
      //   );
      // }
      if (dragDeleteData.draggedItemContainer.id.startsWith(dragAddData.droppedContainer.json.id)) {
        bufferForm = await updateProps(
          formcreation,
          droppedContainerSplits,
          { fields: dragAddData.droppedContainer.json.fields },
          false
        );
        finalForm = await updateProps(
          bufferForm,
          itemContainerSplits,
          { fields: dragDeleteData.draggedItemContainer.fields },
          false
        );
      } else {
        bufferForm = await updateProps(
          formcreation,
          itemContainerSplits,
          { fields: dragDeleteData.draggedItemContainer.fields },
          false
        );
        finalForm = await updateProps(
          bufferForm,
          droppedContainerSplits,
          { fields: dragAddData.droppedContainer.json.fields },
          false
        );
      }
    }

    dispatch({
      type: UPDATE_PROPERTIES,
      data: {
        id: dragDeleteData.formid || dragAddData.formid,
        data: finalForm,
      },
    });
  };
}

export function addThemeInfo(data: ThemeInfo) {
  return async function (dispatch: any) {
    const reduxStore = _.cloneDeep(store.getState());
    const formcreation = reduxStore.formcreation[data.formId];

    if (formcreation && formcreation.length) {
      formcreation[0].theme = data.theme;
      dispatch({
        type: ADD_THEME_INFO,
        data: {
          id: data.formId,
          data: formcreation,
        },
      });
    }
  };
}

export function autoCompleteVariables(data: any[]) {
  return async function (dispatch: any) {
    dispatch({
      type: AUTO_COMPLETE_VARIABLES,
      data: data,
    });
  };
}

export function saveOriginalFormData(data: any) {
  return {
    type: SAVE_ORIGINAL_FORM_DATA,
    data: data
  }
}

export function removeForm(data:any){
  return{
    type:REMOVE_FORM,
    data:data
  }
}

export function removeComponentsAndAdd(data: any, addData: any, deleteOnly = false) {
  return async function (dispatch: any) {
    const { selectedItemsId, formId } = data;
    const reduxStore = _.cloneDeep(store.getState());
    let bufferForm;

    for (const [idx, id] of selectedItemsId.entries()) {
      if (idx === 0) {
        const deleteData = getDeleteData(id, formId, reduxStore)
        bufferForm = await deleteComponent(deleteData)
      } else {
        const deleteData = getDeleteData(id, formId, {}, bufferForm)
        bufferForm = await deleteComponent(deleteData, bufferForm)
      }
    }

    const formData = {
      id: formId,
      data: bufferForm
    }

    if (deleteOnly) {
      dispatch(updateForms(formData))
    } else {
      dispatch(addFormJson(addData, bufferForm));
    }
  }
}

// helper function for `removeComponentsAndGroup` action creator
function getDeleteData(id: string, formId: string, store = {}, providedForm = []) {
  const cardIdSplit = id.split('#');
  cardIdSplit.pop()
  const cardContainer = findIdSelector(store, formId, cardIdSplit, true, providedForm)

  const deleteData = {
    formid: formId,
    itemId: id,
    draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
  }

  return deleteData
}

export function ungroup(data: any) {
  return async function (dispatch: any) {
    const { fields, formId, containerId } = data;
    const reduxStore = _.cloneDeep(store.getState());
    let bufferForm;

    for (const [idx, field] of fields.entries()) {
      if (idx === 0) {
        const addData = getAddData(field, formId, reduxStore)
        bufferForm = await addComponent(addData)
      } else {
        const addData = getAddData(field, formId, {}, bufferForm)
        bufferForm = await addComponent(addData, bufferForm)
      }
    }

    const deleteData = getDeleteData(containerId, formId, {}, bufferForm)
    const updatedForm = await deleteComponent(deleteData, bufferForm)

    dispatch({
      type: CREATE_FORMS,
      data: {
        id: formId,
        data: updatedForm
      }
    })
  }
}

export function selectedForm(data: any) {
  return {
    type: SET_SELECTED_FORM_DATA,
    data: data
  }
}

export function unImportFormWidgetProperties(payload: { formid: string, result: any }) {
  return {
    type: UPDATE_FORM_WIDGET_PROPERTIES,
    data: payload
  }
};

// helper function for `ungroup` action creator
function getAddData(item: any, formId: string, store = {}, providedForm = []) {
  const cardIdSplit = item.id.split('#');
  cardIdSplit.pop()
  const cardContainer = findIdSelector(store, formId, cardIdSplit, true, providedForm)

  const addData = {
    formid: formId,
    draggedItem: item,
    droppedContainer: { json: cardContainer },
  };

  return addData;
}
